var iPad = navigator.userAgent.toLowerCase().indexOf('ipad') != -1;
var safariDesk = $('html').is('.b_safari.d_desktop');
if (iPad) {
  $('body').addClass('p_ios').addClass('d_tablet');
}
var mobDevice = $('html').is('.p_android, .p_ios');
var $window = $(window);
var $document = $(document);
var $leftCol = $('.left-col');

var $lanterns = $('main');
var lanternsTop = $lanterns.position().top;

var sec2 = $('.wall-two .left-col');
var sec3 = $('.wall-three .left-col');
var backgrounds = $('main, .bg-tiny-lanterns, .bg-small-lanterns, .foreground');
var unclicked = true;

function LanternWall() {
  var $this = null;
  var $data = null;
  var _this = this;

  this.$element = null;
  this.top = 0;

  this.settings = {
    left: 0,
    top: 0,
    scrollPosition: 0,
    zIndex: 2,
    initials: null,
    state: null,
    cureDate: null,
    container: 'main',
    extraClass: 'anon'
  }
  $.extend(this.settings, arguments[0]);

  this.render = function() {
    $this = $('<div class="lantern"></div>');
    lanternImg = $('<div class="lanternImg"></div>');
    this.$element = $this;
    $this.css({
      left: this.settings.left
      //top: this.settings.top
    });
    switch (this.settings.zIndex) {
      case 0:
        $this.addClass('z0');
        break;
      case 1:
        $this.addClass('z1');
        break;
    }

    $this.addClass('ltype' + evoke.core.getRandomInt(1, 7));

    if (this.settings.initials != null) {
      if (typeof(this.settings.cured) != 'undefined' && typeof(this.settings.cured) == 'string') {
        this.settings.cured = new Date(this.settings.cured);
      }
      var html = '<div class="data" data-overlaytype="' + this.settings.extraClass + '"><div class="tbl ' + this.settings.extraClass + '"><div class="td">';
      var curedWhen = '<strong>I LET GO</strong> of Hep&nbsp;C';
      if (typeof(this.settings.cured) != 'undefined') {
        var years = LanternWall.now.getFullYear() - this.settings.cured.getFullYear();
        if (years == 0) {
          var months = LanternWall.now.getMonth() - this.settings.cured.getMonth();
          curedWhen += ('<br><span class="date">' + months.toString() + '&nbsp;month' + (months != 1 ? 's' : '') + '&nbsp;ago</span>');
        } else {
          var months = LanternWall.now.getMonth() + 12 - this.settings.cured.getMonth();
          if (months > 11) {
            months -= 12;
            years += 1;
          }
          curedWhen += ('<br><span class="date">' + years.toString() + '&nbsp;year' + (years != 1 ? 's' : '') + (months > 0 ? ' and ' + months.toString() + '&nbsp;month' + (months != 1 ? 's' : '') : '') + '&nbsp;ago</span>');
        }
      }
      html += ('<div class="cureWhen">' + curedWhen + '</div><div class="who">' + this.settings.initials + ', ' + this.settings.state + '</div>');
      if (typeof(this.settings.cured) != 'undefined') {
        html += ('<div class="cureDate">Cured: ' + (this.settings.cured.getMonth() + 1).toString() + '/' + this.settings.cured.getFullYear().toString() + '</div>');
      }
      var buttonVerb = "See";
      if (typeof (this.settings.type) != 'undefined') {
          switch (this.settings.type.toLowerCase()) {
              case 'article':
                  buttonVerb = 'Read';
                  break;
          }
      }
      html += '<div class="storyButton">' + buttonVerb + ' my story</div></div></div></div>';

      $data = $(html); //'<div class="data" data-overlaytype="' + this.settings.extraClass + '"><div class="tbl ' + this.settings.extraClass + '"><div class="td"><div class="cureWhen">' + curedWhen + '</div><div class="who">' + this.settings.initials + ', ' + this.settings.state + '</div><div class="cureDate">Cured: ' + (this.settings.cured.getMonth() + 1).toString() + '/' + this.settings.cured.getFullYear().toString() + '</div><div class="storyButton">See my story</div></div></div></div>');
      $this.append($data);


      if (this.settings.left > ($leftCol.width() / 2) - 75) {
        $data.addClass('left');
      } else {
        $data.addClass('right');
      }


    }

    $this.append(lanternImg);
    $(this.settings.container).append($this);
    LanternWall.lanterns.push(this);
  }

  this.moveY = this.settings.top;

  this.scrollStart = function() {
    _this.moveY = parseInt($this.css('top'), 10);
  }
  this.scrollStop = function() {

  }
  var timeout = [];
  var prevDirection = 'up';
  this.move = function(y) {
    _this.moveY += y;
    if ((y < 0 && prevDirection == 'up') || (y > 0 && prevDirection == 'down')) {
      // $this.stop();
      //timeout.forEach(function (item) { clearTimeout(item); });
      //timeout = [];
    }
    // if (mobDevice) {
    //     _this.moveY -= y;
    // } else {
    //     _this.moveY += y;
    // }
    //$this.get(0).style.top = _this.moveY.toString() + 'px';
    $this.get(0).style.transform = 'translateY(' + _this.moveY.toString() + 'px)';
    //$this.animate({ top: _this.moveY }, { duration: y * 4, easing: 'linear' });
    //timeout.push(setTimeout(function () {
    //    $this.get(0).style.top = _this.moveY.toString() + 'px';
    //}, 50));
  }

  this.showData = function() {
    if ($data != null) {
      var offsetTop = $this.offset().top;
      if (offsetTop < $window.height() + $document.scrollTop() - $data.height()) { //$data.width() < 204 &&

        var width = $window.height() + $document.scrollTop() - $data.height() - offsetTop;
        if (width > 230) {
          width = 500;
        }
        var opacity = width / 500;
        $data.css({
          maxWidth: width,
          opacity: opacity
        });
      }
    }
  }
}
LanternWall.now = new Date();
LanternWall.$document = $(document);
LanternWall.$window = $(window);
LanternWall.lanterns = [];
LanternWall.lastScrollPosition = LanternWall.$document.scrollTop();
LanternWall.scroll = function() {
  var scrollTop = LanternWall.$document.scrollTop();
  var winHeight = LanternWall.$window.height();
  setBackgroundHeight();
  if ($lanterns.offset().top + $lanterns.height() > winHeight / 2 + scrollTop) {
    LanternWall.lanterns.forEach(function(item) {
      var offsetTop = item.$element.offset().top;
      if (offsetTop < winHeight + scrollTop) { //visible
        switch (item.settings.zIndex) {
          case 0:
            if (!iPad) {
              item.move((scrollTop - LanternWall.lastScrollPosition) / 2);
            }
            //item.settings.top += ((scrollTop - LanternWall.lastScrollPosition) / 2);
            //if (window.navigator.userAgent.toLowerCase().indexOf('ipad') != -1) {
            //    item.$element.stop();
            //    item.$element.animate({
            //        top: '+=' + top
            //    }, {
            //        duration: 10,
            //        easing: 'linear'
            //    });
            //} else {
            //item.$element.get(0).style.top = item.settings.top.toString() + 'px';
            /*item.$element.css({
                top: '+=' + top
            });*/
            //}
            break;
          case 1:
            if (!iPad) {
              item.move((scrollTop - LanternWall.lastScrollPosition) / 1.5);
            }
          default:
            break;
        }
      }
      //item.showData();
    });
  }
  // if (sec3.offset().top < winHeight / 2 + scrollTop && unclicked === true) {
  //     $.modalDialog.show('.patient-directory');
  //     unclicked = false;
  // }
  LanternWall.lastScrollPosition = scrollTop;
};
LanternWall.scrollStart = function() {
  LanternWall.lanterns.forEach(function(item) {
    item.scrollStart();
  });
};
LanternWall.scrollStop = function() {
  LanternWall.lanterns.forEach(function(item) {
    item.scrollStop();
  });
};

//LanternWall.$window.on('scrollstart', LanternWall.scrollStart);
//LanternWall.$window.on('scroll', LanternWall.scroll);
//LanternWall.$window.on('scrollstop', LanternWall.scrollStop);


//var winHeight = $window.height();
//var winWidth = $window.width();
//var center = Math.floor(winWidth / 2);

var CureData = (function() {
  var index = 0;
  var data = null;

  function randomize(cureData) {
    var cures = cureData.slice();
    var randomized = [];
    var totalCures = cureData.length;
    var index = 0;
    while (randomized.length < totalCures) {
      index = evoke.core.getRandomInt(0, cures.length);
      randomized.push(cures[index]);
      cures.splice(index, 1);
    }
    return randomized;
  }

  return {
    set: function(cureData) {
      data = randomize(cureData);
    },
    next: function() {
      if (index < data.length) {
        return data[index++];
      } else {
        index = 0;
        return data[0]
      }
    }
  }
})();

CureData.states = {
  'AL': 'Alabama',
  'AK': 'Alaska',
  'AZ': 'Arizona',
  'AR': 'Arkansas',
  'CA': 'California',
  'CO': 'Colorado',
  'CT': 'Connecticut',
  'DE': 'Delaware',
  'DC': 'Dist of Columbia',
  'FL': 'Florida',
  'GA': 'Georgia',
  'GU': 'Guam',
  'HI': 'Hawaii',
  'ID': 'Idaho',
  'IL': 'Illinois',
  'IN': 'Indiana',
  'IA': 'Iowa',
  'KS': 'Kansas',
  'KY': 'Kentucky',
  'LA': 'Louisiana',
  'ME': 'Maine',
  'MD': 'Maryland',
  'MA': 'Massachusetts',
  'MI': 'Michigan',
  'MN': 'Minnesota',
  'MS': 'Mississippi',
  'MO': 'Missouri',
  'MT': 'Montana',
  'NE': 'Nebraska',
  'NV': 'Nevada',
  'NH': 'New Hampshire',
  'NJ': 'New Jersey',
  'NM': 'New Mexico',
  'NY': 'New York',
  'NC': 'North Carolina',
  'ND': 'North Dakota',
  'OH': 'Ohio',
  'OK': 'Oklahoma',
  'OR': 'Oregon',
  'PA': 'Pennsylvania',
  'PR': 'Puerto Rico',
  'RI': 'Rhode Island',
  'SC': 'South Carolina',
  'SD': 'South Dakota',
  'TN': 'Tennessee',
  'TX': 'Texas',
  'UT': 'Utah',
  'VT': 'Vermont',
  'VI': 'Virgin Islands',
  'VA': 'Virginia',
  'WA': 'Washington',
  'WV': 'West Virginia',
  'WI': 'Wisconsin',
  'WY': 'Wyoming'
};

$(document).ready(function() {

  // var dataPath = '/~/media/Files/harvoni_com/json/cures.json';
  // if (location.hostname.toLowerCase() == 'localhost') {
  //     dataPath = '/js/common/cureData.min.json';
  // }
  // evoke.core.loadJson(dataPath, function (data) {
  //     CureData.set(data);
  //     var lanterns = [];
  //     var leftSetting;
  //     var dataW;
  //     for (var i = 0; i < 9; i++) {
  //         switch (i) {
  //             case 0:
  //                 lanterns.push(new LanternWall({
  //                     left: evoke.core.getRandomInt($leftCol.width() / 2 - 125, $leftCol.width() / 2 + 125),
  //                     top: i * 200 + 50,
  //                     initials: 'Terry C.',
  //                     state: 'California',
  //                     extraClass: 'terry',
  //                     container: '.wall-two .left-col .lanternContainer'
  //                 }));
  //                 break;
  //             case 1:
  //                 lanterns.push(new LanternWall({
  //                     left: evoke.core.getRandomInt($leftCol.width() / 2 - 125, $leftCol.width() / 2 + 125),
  //                     top: i * 200 + 50,
  //                     initials: 'Charlotte S.',
  //                     state: 'Tennessee',
  //                     extraClass: 'charlotte',
  //                     container: '.wall-two .left-col .lanternContainer'
  //                 }));
  //                 break;
  //             case 5:
  //                 lanterns.push(new LanternWall({
  //                     left: evoke.core.getRandomInt($leftCol.width() / 2 - 125, $leftCol.width() / 2 + 125),
  //                     top: i * 200 + 50,
  //                     initials: 'Mitch S.',
  //                     state: 'California',
  //                     extraClass: 'mitch',
  //                     container: '.wall-two .left-col .lanternContainer'
  //                 }));
  //                 break;
  //             default:
  //                 {
  //                     var cure = CureData.next();
  //                     lanterns.push(new LanternWall({
  //                         left: evoke.core.getRandomInt($leftCol.width() / 2 - 125, $leftCol.width() / 2 + 125),
  //                         top: i * 200 + 50,
  //                         initials: cure.name,
  //                         state: CureData.states[cure.state],
  //                         cured: cure.date,
  //                         container: '.wall-two .left-col .lanternContainer'
  //                     }));
  //                 }
  //                 break;
  //         }
  //     }
  //     for (var i = 0; i < 7; i++) {
  //         switch (i) {
  //             case 1:
  //                 lanterns.push(new LanternWall({
  //                     left: evoke.core.getRandomInt($leftCol.width() / 2 - 125, $leftCol.width() / 2 + 125),
  //                     top: i * 200 + 50,
  //                     initials: 'William J.',
  //                     state: 'Ohio',
  //                     extraClass: 'william',
  //                     container: '.wall-three .left-col .lanternContainer'
  //                 }));
  //                 break;
  //             case 4:
  //                 lanterns.push(new LanternWall({
  //                     left: evoke.core.getRandomInt($leftCol.width() / 2 - 125, $leftCol.width() / 2 + 125),
  //                     top: i * 200 + 50,
  //                     initials: 'Carol J.',
  //                     state: 'Connecticut',
  //                     extraClass: 'carol',
  //                     container: '.wall-three .left-col .lanternContainer'
  //                 }));
  //                 break;
  //             default:
  //                 {
  //                     var cure = CureData.next();
  //                     lanterns.push(new LanternWall({
  //                         left: evoke.core.getRandomInt($leftCol.width() / 2 - 125, $leftCol.width() / 2 + 125),
  //                         top: i * 200 + 50,
  //                         initials: cure.name,
  //                         state: CureData.states[cure.state],
  //                         cured: cure.date,
  //                         container: '.wall-three .left-col .lanternContainer'
  //                     }));
  //                     break;
  //                 }
  //         }
  //     }
  // for (var i = 0; i < lanterns.length; i++) {
  //     lanterns[i].render();
  //     leftSetting =  lanterns[i].settings.left;
  //     dataW =  lanterns[i].$element.find('.data').outerWidth();

  //     if (lanterns[i].$element.find('.data').hasClass('left')) {
  //         if (dataW > leftSetting) {
  //             lanterns[i].$element.css('left', dataW + 10);
  //         }
  //     } else {
  //         if (dataW + 90 + leftSetting > $leftCol.width()) {
  //             lanterns[i].$element.css('left', $leftCol.outerWidth() - (dataW + 90));
  //         }
  //     }

  // }
  // LanternWall.scroll();
  // });

  $('header,  nav.nav-main .sub-nav, #wall-one, #wall-two, #wall-three, footer').each(function() {
    $(this).append('<div class="rpsGrayout"></div>');
  });



  if (safariDesk) {
    LanternAnimation.create({
      container: '.bg-stars',
      dataContainer: '.left-col',
      layers: [{
        ratio: 0.33
      }]
    });
  } else {
    LanternAnimation.create({
      container: '.bg-stars',
      dataContainer: '.left-col',
      layers: [{
        ratio: 0.33
      }, {
        ratio: 0.66
      }]
    });
  }


  LanternAnimation.create({
    container: '.wall-two .lanternContainer',
    dataContainer: '.lanternbox',
    layers: [{
      isCure: true,
      ratio: 1
    }]
  });

  // LanternAnimation.create({
  //   container: '.wall-three .lanternContainer',
  //   dataContainer: '.lanternbox',
  //   layers: [{
  //     isCure: true,
  //     ratio: 1
  //   }]
  // });




  var jscrollAPIs = [];

  if (evoke.core.windowWidth() > 1000) {

    $('.scroll-content').each(
      function() {
        jscrollAPIs.push($(this).jScrollPane({
          verticalGutter: 21,
          autoReinitialise: true
        }).data().jsp);
      }
    );

  }

  $window.on('resizeEnd', function() {

    if (evoke.core.windowWidth() < 1000) {
      if (jscrollAPIs.length) {
        $.each(
          jscrollAPIs,
          function(i) {
            this.destroy();
          }
        )
        jscrollAPIs = [];
      }
    } else {
      if (!jscrollAPIs.length) {
        $('.scroll-content').each(
          function() {
            jscrollAPIs.push($(this).jScrollPane().data().jsp);
          }
        );
      }
    }

  });

});



function setBackgroundHeight() {

  var reduceBy = 0;

  if (evoke.core.windowWidth() > 1000) {
    reduceBy = $('header').outerHeight() + $('.nav-main > ul > li.active > .sub-nav').outerHeight();
  }

  evoke.$('.bg-stars').height(evoke.$(window).height() - reduceBy);
  evoke.core.console.log(evoke.$('.bg-stars').height());
}



function resetLanterns() {

  var lcol = $('.left-col').width();
  var lcolWdth = lcol / 2;

  $('.lanternContainer .lantern').each(function(item) {

    var _this = $(this),
      _thisWidth = $(this).width(),
      $data = _this.find('.cure'),
      $dataWidth = $data.width(),
      lanternWidth = _thisWidth + $dataWidth,
      newleft = evoke.core.getRandomInt(0, lcol - 70),
      newleftmargin = evoke.core.getRandomInt(2, 50);

    if (newleft - lanternWidth < 0) {
      newleft = newleftmargin;
    } else if (newleft + lanternWidth > lcol) {
      newleft = lcol - lanternWidth - newleftmargin;
    }

    _this.css('left', newleft);

    if (newleft > lcolWdth) {
      _this.removeClass('left').addClass('right');
    } else {
      _this.removeClass('right').addClass('left');
    }

  });

}


var lanternMover = (function() {
    
  var wallTwo     = $('.wall-two .lanternPort'),
      wallThree   = $('.wall-three .lanternPort'),
      lContainer  = $('.lanternContainer');

  return {

    check: function() {

      var wallTwoTop = wallTwo.offset().top,
          wallTwoBottom = wallTwoTop + wallTwo.height(),
          winTop = $window.scrollTop();

      if (wallTwoBottom < winTop) {

        if (!wallThree.hasClass('got-lanterns')) {

          lanternMover.swap(wallThree,wallTwo);

        }

      } else {

        if (!wallTwo.hasClass('got-lanterns')) {

          lanternMover.swap(wallTwo,wallThree);

        }

      }

    },
    swap: function(x,y) {

      x.addClass('got-lanterns');
      y.removeClass('got-lanterns');
      lContainer.appendTo(x);

    }

  };

})();


var storyViewer = (function() {

  var directory = $('.patient-directory'),
    basic = $('.basic-card'),
    stories = $('.stories-slider'),
    video = $('.video-overlay'),
    videoClose = video.find(".close"),
    overlayTrigger = $('[data-overlaytype]'),
    openFromDir = false,
    videoID,
    videoName;
  
  $document.ready(function () {
      storyViewer.patientVideoPlayer = new evoke.ui.VimeoPlayer({
          container: '#patientVideoPlayer',
          videos: [
              { name: 'terry', callouts: ['facts', 'specialist'] },
              { name: 'mitch', callouts: ['facts', 'copay'] },
              { name: 'carol', callouts: ['facts', 'specialist'] },
              { name: 'commercial', callouts: ['facts', 'copay'] },
              { name: 'bill', callouts: ['facts', 'specialist'] },
              { name: 'shayne', callouts: ['facts', 'copay'] },
              { name: 'rebecca', callouts: ['facts', 'specialist'] },
              { name: 'rob', callouts: ['facts', 'copay'] }
          ]
      });
      $("#patientVideoPlayer").data("played", false);
  });

  return {
      patientVideoPlayer: null,
    init: function() {

      $('.foreground').on('click', '[data-overlaytype]', function(e) {
        e.preventDefault();

        var _this = $(this),
          overtype = _this.data('overlaytype'),
          isDir = _this.hasClass('directory-button') ? true : false;

        unclicked = false;

        openFromDir = isDir;

        //stories.hide();

        storyViewer.showOverlay(_this, overtype);

        evoAnalytics.trackEvent($(this).data('analytics-event'));

        if (!isDir) {
          //evoke.gtm.trackEvent($(this).data('evo-gtm'));
        }

      });
      //videoClose.data("orig-evo-gtm", videoClose.data("evo-gtm"));
      videoClose.add('.rpsGrayout').add('.story-card .close').add('.basic-card .close').on('click', function (e) {
          e.preventDefault();
        $.modalDialog.hide(/*{
          onHide: function() {
              patientVideoPlayer.pause();
          }
        }*/);
      });


      $('.open-video').each(function () {
          $(this).click(function (e) {
              e.preventDefault();

              var _this = $(this),
                vidName = _this.data('openvid');


              var $patientVideoPlayer = $("#patientVideoPlayer");
              if ($patientVideoPlayer.data("played") !== true) {
                  //VIMEO MODALDIALOG PLAY HACK
                  video.children().each(function () {
                      $(this).css("visibility", "hidden");
                  });
                  video.css({
                      "position": "absolute",
                      "display": "block"
                  });
              }
              $.modalDialog.show(video, null, {
                  callback: function () {
                      if ($patientVideoPlayer.data("played") !== true) {
                          //VIMEO MODALDIALOG PLAY HACK
                          video.children().each(function () {
                              $(this).css("visibility", "visible");
                          });
                          $patientVideoPlayer.data("played", true);
                      }
                      //evoke.ui.VimeoPlayer.instance("#patientVideoPlayer").play();
                      storyViewer.patientVideoPlayer.play(vidName);
                  },
                  onHide: function () {
                      storyViewer.patientVideoPlayer.pause();
                      storyViewer.patientVideoPlayer.trigger(evoke.ui.VimeoPlayer.EVENT_CLOSE);
                  },
                  grayoutSelector: '.rpsGrayout'
              });

          });
      });

    },
    showOverlay: function(x, y) {

      switch (y) {
        case 'anon':
          storyViewer.openBasic(x);
          break;
        default:
          storyViewer.openStory(x);
      }

    },
    openStory: function(x) {

      var overtype = x.data('overlaytype');

      switch (overtype) {
        case 'terry':
          $('.slickslider').slick('slickGoTo', 0, false);
          break;
        case 'mitch':
          $('.slickslider').slick('slickGoTo', 1, false);
          break;
        case 'carol':
          $('.slickslider').slick('slickGoTo', 2, false);
          break;
        case 'william':
          $('.slickslider').slick('slickGoTo', 3, false);
          break;
        case 'charlotte':
          $('.slickslider').slick('slickGoTo', 4, false);
          break;
        case 'bill':
          $('.slickslider').slick('slickGoTo', 5, false);
          break;
        case 'shayne':
          $('.slickslider').slick('slickGoTo', 6, false);
          break;
        case 'rebecca':
          $('.slickslider').slick('slickGoTo', 7, false);
          break;
        case 'rob':
          $('.slickslider').slick('slickGoTo', 8, false);
          break;
      }

      storyViewer.showStory(x);

    },
    showStory: function(x) {

      // var calcTop = Math.floor(x.offset().top + x.height() + 20);

      $.modalDialog.show(stories, document.forms[0], {
        dialogPosition: 'absolute',
        grayoutSelector: '.rpsGrayout'
        //animation: null
        //top: calcTop,
        // opacity: 0,
        // callback: function () {
        //     $('#evokeModalDialogGrayout').hide();
        // }
      });

    },
    insertStory: function(x) {

      var trigger = (x.hasClass('data')) ? x.parents('.lantern') : x;

      //trigger.after(stories);
      stories.insertAfter(trigger).show();

    },
    openBasic: function(x) {

      var content = x.find('.td').html();
      var calcTop = Math.floor(x.offset().top + x.height() + 20);
      var dateCured = x.data('cure-date');


      storyViewer.updateBasicFeaturedContent(content,dateCured);

      var buttonStory = ["terry", "mitch", "carol"][evoke.core.random(0, 2, true)];
      basic.find("button.story").each(function () {
          var $this = $(this);
          if ($this.hasClass(buttonStory)) {
              $this.removeClass("hidden");
          } else {
              $this.addClass("hidden");
          }
      });

      $.modalDialog.show(basic, document.forms[0], {
        dialogPosition: 'absolute',
        grayoutSelector: '.rpsGrayout'
      });

    },
    updateBasicFeaturedContent: function(x,y) {

      var featuredContent = basic.find('.featured');
      var otherList = basic.find('.others');
      var otherCount = 10;
      var otherContent;
      var others = LanternAnimation.data.get(otherCount, y);

      featuredContent.html(x);
      otherList.html('');

      for (var i = 0; i < otherCount; i++) {

        var thisDate  = new Date(others[i].date);
        var month     = (thisDate.getMonth() + 1).toString();
        var year      = thisDate.getFullYear().toString();

        otherContent = '<button type="button"><div class="who"><strong>' + others[i].name + ',</strong> ' + others[i].state + '</div><div class="cureDate">Cured ' + month + '/' + year + '</div></button>';

        $(otherList).append(otherContent);

      }

    },
    openVideo: function(x) {

    }

  };

})();
storyViewer.init();

$(document).ready(function () {
    storyViewer.patientVideoPlayer.ready(function () {
        var vidName = httpUtility.queryString('video');
        if (vidName != null) {
            //var $patientVideoPlayer = $("#patientVideoPlayer");
            //if ($patientVideoPlayer.data("played") !== true) {
            //    //VIMEO MODALDIALOG PLAY HACK
            //    $patientVideoPlayer.children().each(function () {
            //        $(this).css("visibility", "hidden");
            //    });
            //    $patientVideoPlayer.css({
            //        "position": "absolute",
            //        "display": "block"
            //    });
            //}
            $.modalDialog.show($('.video-overlay'), null, {
                callback: function () {
                    //if ($patientVideoPlayer.data("played") !== true) {
                    //    //VIMEO MODALDIALOG PLAY HACK
                    //    $patientVideoPlayer.children().each(function () {
                    //        $(this).css("visibility", "visible");
                    //    });
                    //    $patientVideoPlayer.data("played", true);
                    //}
                    storyViewer.patientVideoPlayer.play(vidName);
                    $patientVideoPlayer.data("played", true);
                },
                onHide: function () {
                    storyViewer.patientVideoPlayer.pause();
                    storyViewer.patientVideoPlayer.trigger(evoke.ui.VimeoPlayer.EVENT_CLOSE);
                }
            });
        }
    });
});


var like = (function() {

    var likeArr = [];//,
    //assetCode;

  return {

    init: function() {


      like.remember();


      $('.stories-slider').on('click', '[data-like]', function() {

        var _this = $(this);

        if (!_this.hasClass('liked')) {
          like.who(_this);
        }

      });

    },
    who: function(x) {
        var asset = x.data("like-asset");
        //if (asset == undefined) {
        //    var who = x.data('like');
        //    switch (who) {
        //        case 'terry':
        //            asset = '913982E7-47BD-440A-AFC5-3B7FD08BC861';
        //            break;
        //        case 'mitch':
        //            asset = '54783FEC-0BB4-4D17-B01F-2F5264BF4C09';
        //            break;
        //        case 'carol':
        //            asset = '178041E7-BD83-4E27-85B9-9EC021FEB0E9';
        //            break;
        //        case 'william':
        //            asset = 'B7580EAE-BBDF-434E-8911-F90B8D433487';
        //            break;
        //        case 'charlotte':
        //            asset = '32679D73-3BF7-490D-A9BD-D1AAD5C724E7';
        //            break;
        //        case 'bill':
        //            asset = '14C1163E-1E9A-4BB2-BA7E-7E0943F19400';
        //            break;
        //        case 'shayne':
        //            asset = 'F4F57B13-686E-474E-8DC6-9D4C9A777057';
        //            break;
        //        case 'rebecca':
        //            asset = '4D84018B-FFE6-4BF5-BDDC-F7226261EB42';
        //            break;
        //        case 'rob':
        //            asset = 'A8902599-5EEC-4AD2-BC7D-DF06DC0EEA35';
        //            break;
        //    }
        //}

        like.post(asset, x);

    },
    post: function(assetCode, x) {

      $.post('/sofldv_str/harvoni_com/v2/handlers/like.ashx', {
          asset: assetCode
        })
        .done(function(data) {
          x.addClass('liked');
          likeArr.push(x.data('like'));
          var json_str = JSON.stringify(likeArr);

          like.setCookie(json_str);

        });

    },
    setCookie: function(cookieData) {
      httpUtility.cookie.set('likeCookie', cookieData);
    },
    getCookie: function() {

      var likes = httpUtility.cookie.get('likeCookie');

      if (likes) {
        likeArr = JSON.parse(likes);
      }

    },
    remember: function() {

      like.getCookie();

      $.each(likeArr, function(index, value) {

        $('[data-like="' + value + '"]').addClass('liked');

      });

    }

  };

})();
like.init();


$('.slickslider').slick({
  dots: false,
  adaptiveHeight: false,
  prevArrow: '<a href="javascript:void(0);" class="slick-prev" data-analytics-event="[\'Real Patient Stories Cards\',\'Click\',\'Left Arrow Navigation\']" data-evo-gtm="Real Patient Stories Cards|Clicked|Left Arrow Navigation|Real Patient Stories"></a>',
  nextArrow: '<a thref="javascript:void(0);" class="slick-next" data-analytics-event="[\'Real Patient Stories Cards\',\'Click\',\'Right Arrow Navigation\']" data-evo-gtm="Real Patient Stories Cards|Clicked|Right Arrow Navigation|Real Patient Stories"></a>'
});

$window.on('scroll', function () {

  lanternMover.check();

});

//$window.on('scrollEnd', function () {

//});

$window.on('resizeEnd', function() {

  resetLanterns();
  $.modalDialog.refresh(true);

});